import { jsx as _jsx } from "react/jsx-runtime";
import './Prototypes/_index';
import React from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app, { createReducer } from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import QuickSearch from './Components/QuickSearch';
import CartAddToastRoot from './Components/CartAddToast';
import Navigation from './Components/Navigation';
import FacetedSearch from './Components/FacetedSearch';
import FacetedSearchCompactContainer from './Components/FacetedSearchCompactContainer';
import DynamicComponent from './Components/DynamicComponent';
import HeaderCartButton from "./Components/HeaderCartButton";
import HeaderFavoritesButton from "./Components/HeaderFavoritesButton";
import HeaderUserButton from "./Components/HeaderUserButton";
import { filterCustomScripts } from './Components/Filter-scripts';
import Subnav from "./VanillaJS/subnav";
import Faqs from "./VanillaJS/faqs";
import ProductPageNav from "./VanillaJS/product-page-nav";
import OrganizationSearch from "./Components/OrganizationSearch";
import LiveEditing from "./Components/LiveEditing";
import { channelSelector } from './VanillaJS/HeaderTopRow';
window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
const store = createStore(app, preloadState, composeWithDevTools(applyMiddleware(thunk, historyMiddleware)));
// Add a dictionary to keep track of the registered async reducers
store.asyncReducers = {};
// Create an inject reducer function
// This function adds the async reducer, and creates a new combined reducer
store.injectReducer = (key, asyncReducer) => {
    if (!store.asyncReducers[key]) {
        store.asyncReducers[key] = asyncReducer;
        store.replaceReducer(createReducer(store.asyncReducers));
    }
};
window.__litium = {
    ...window.__litium,
    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. ReactDOM.render performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    cache: {}, // for storing cache data for current request
};
import { createRoot } from 'react-dom/client';
const roots = new Map(); // Store roots by container
const renderReact = (element, container) => {
    if (!container)
        return;
    // Check if we have a root AND if that root's container is still in the DOM
    const existingRoot = roots.get(container);
    const isNodeDetached = !document.contains(container);
    if (!existingRoot || isNodeDetached) {
        // If the node was replaced by AJAX, the old root is useless.
        // We create a new one for the new DOM element.
        roots.set(container, createRoot(container));
    }
    roots.get(container).render(element);
};
function insertParam(key, value) {
    if (history.pushState) {
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?${key}=${value}`;
        window.history.pushState({ path: newurl }, '', newurl);
    }
}
/**
 *
 * @param {MouseEvent} e
 * @returns {boolean}
 */
const setUrlTabUrl = function (e) {
    insertParam('currentTab', this.getAttribute('for'));
};
window.onload = function () {
    new Subnav();
    new Faqs();
    new ProductPageNav();
    let tabs = document.querySelectorAll('.my-pages label.tab__header');
    if (tabs.length) {
        tabs.addEventListener('click', setUrlTabUrl);
    }
    filterCustomScripts();
    channelSelector();
};
window.onunload = () => {
    // make sure components are unmounted, redux's listener are unsubscribed
    // to fix issue with iframe navigation in IE
    roots.forEach((root, container) => {
        root.unmount();
    });
    roots.clear();
};
/**
 *
 * @param {Event} e
 */
function categoryFilterRendered(e) {
    let subnavCloseButtonEl = document.querySelectorAll('.js-subnav-close');
    if (subnavCloseButtonEl.length) {
        const SubnavCloseButton = DynamicComponent({
            loader: () => import('./Components/SubnavCloseButton'),
        });
        subnavCloseButtonEl.forEach((el) => {
            renderReact(_jsx(Provider, { store: store, children: _jsx(SubnavCloseButton, {}) }), el);
        });
    }
}
const bootstrapComponents = () => {
    document.addEventListener('categoryFilterRendered', categoryFilterRendered);
    // Mount global cart-add toast root (singleton). Safe to create container if missing.
    let toastContainer = document.getElementById('cart-add-toast-root');
    if (!toastContainer) {
        toastContainer = document.createElement('div');
        toastContainer.id = 'cart-add-toast-root';
        document.body.appendChild(toastContainer);
    }
    renderReact(_jsx(Provider, { store: store, children: _jsx(CartAddToastRoot, {}) }), toastContainer);
    if (document.getElementById('liveEditing')) {
        renderReact(_jsx(Provider, { store: store, children: _jsx(LiveEditing, {}) }), document.getElementById('liveEditing'));
    }
    let userButton = document.getElementById('header-user-button');
    if (userButton) {
        let props = JSON.parse(userButton.dataset.props);
        if (('enabled' in props) && props.enabled) {
            renderReact(_jsx(Provider, { store: store, children: _jsx(HeaderUserButton, { ...props }) }), userButton);
        }
        else {
            userButton.remove();
        }
    }
    const singleAddToCart = document.getElementById('single-add-to-cart');
    if (singleAddToCart) {
        const SingleAddToCartWrapper = DynamicComponent({
            loader: () => import('./Components/SingleAddToCartWrapper'),
        });
        const variant = JSON.parse(singleAddToCart.dataset.variant);
        renderReact(_jsx(Provider, { store: store, children: _jsx(SingleAddToCartWrapper, { variant: variant }) }), singleAddToCart);
    }
    let favoritesButton = document.getElementById('header-favorites-button');
    if (favoritesButton) {
        let props = JSON.parse(favoritesButton.dataset.props);
        if (('enabled' in props) && props.enabled) {
            renderReact(_jsx(Provider, { store: store, children: _jsx(HeaderFavoritesButton, { ...props }) }), favoritesButton);
        }
        else {
            favoritesButton.remove();
        }
    }
    let miniCart = document.querySelector('#header-cart-button');
    if (miniCart) {
        let props = JSON.parse(miniCart.dataset.props);
        if (('enabled' in props) && props.enabled) {
            renderReact(_jsx(Provider, { store: store, children: _jsx(HeaderCartButton, { ...props }) }), miniCart);
        }
        else {
            miniCart.remove();
        }
    }
    let variantTableSingle = document.querySelector('#variant-table-single');
    if (variantTableSingle) {
        /**
         * @type array
         */
        let variant = __litium.selectedVariant;
        if (typeof variant !== 'undefined' && variant.length) {
            const VariantTable = DynamicComponent({
                loader: () => import('./Components/VariantTable/VariantTable'),
            });
            renderReact(_jsx(Provider, { store: store, children: _jsx(VariantTable, { variants: variant, ignoreDiscountedFilter: false, isSelectedVariant: true }) }), variantTableSingle);
        }
    }
    let variantTable = document.querySelector('#variant-table');
    if (variantTable) {
        /**
         * @type array
         */
        let variants = __litium.variants;
        if (typeof variants !== 'undefined' && variants.length) {
            const VariantTable = DynamicComponent({
                loader: () => import('./Components/VariantTable/VariantTable'),
            });
            renderReact(_jsx(Provider, { store: store, children: _jsx(VariantTable, { variants, ignoreDiscountedFilter: false }) }), variantTable);
        }
    }
    let accessoriesModal = document.querySelector('#accessories-modal');
    if (accessoriesModal) {
        const AccessoriesModal = DynamicComponent({
            loader: () => import('./Components/VariantTable/AccessoriesModal'),
        });
        renderReact(_jsx(Provider, { store: store, children: _jsx(AccessoriesModal, {}) }), accessoriesModal);
    }
    let quickSearch = document.querySelectorAll('.quick-search');
    if (quickSearch.length) {
        quickSearch.forEach(el => {
            renderReact(_jsx(Provider, { store: store, children: _jsx(QuickSearch, {}) }), el);
        });
    }
    // Internal product toggle mount
    const internalToggle = document.getElementById('internalToggle');
    if (internalToggle) {
        const initialHide = internalToggle.dataset.hideInternal === '1';
        const InternalToggle = DynamicComponent({ loader: () => import('./Components/InternalToggle') });
        renderReact(_jsx(Provider, { store: store, children: _jsx(InternalToggle, { initialHide: initialHide }) }), internalToggle);
    }
    let navbar = document.getElementById('navbar');
    if (navbar) {
        let cta = null;
        try {
            cta = JSON.parse(navbar.dataset.cta);
        }
        catch (e) {
            //
        }
        renderReact(_jsx(Provider, { store: store, children: _jsx(Navigation, { isMainNav: true, cta: cta }) }), navbar);
    }
    if (document.getElementById('facetedSearch')) {
        renderReact(_jsx(Provider, { store: store, children: _jsx(FacetedSearch, {}) }), document.getElementById('facetedSearch'));
    }
    if (document.getElementById('facetedSearchCompact')) {
        renderReact(_jsx(Provider, { store: store, children: _jsx(FacetedSearchCompactContainer, {}) }), document.getElementById('facetedSearchCompact'));
    }
    if (document.getElementById('myPagePersons')) {
        const PersonList = DynamicComponent({
            loader: () => import('./Components/PersonListContainer'),
        });
        renderReact(_jsx(Provider, { store: store, children: _jsx(PersonList, {}) }), document.getElementById('myPagePersons'));
    }
    if (document.getElementById('myPageAddresses')) {
        const AddressList = DynamicComponent({
            loader: () => import('./Components/AddressListContainer'),
        });
        let el = document.getElementById('myPageAddresses');
        renderReact(_jsx(Provider, { store: store, children: _jsx(AddressList, {}) }), el);
    }
    if (document.getElementById('checkout')) {
        const Checkout = DynamicComponent({
            loader: () => import('./Components/Checkout'),
        });
        renderReact(_jsx(Provider, { store: store, children: _jsx(Checkout, {}) }), document.getElementById('checkout'));
    }
    if (document.querySelectorAll('.slider').length > 0) {
        const Slider = DynamicComponent({
            loader: () => import('./Components/Slider'),
        });
        Array.from(document.querySelectorAll('.slider')).forEach((slider, index) => {
            const values = [...slider.querySelectorAll('template')].map((block) => {
                return {
                    html: block.innerHTML,
                };
            });
            if (values.length > 0) {
                renderReact(_jsx(Slider, { values: values }), slider);
            }
        });
    }
    let productImagesCarousel = document.querySelectorAll('.product-images');
    if (productImagesCarousel.length) {
        const ProductImages = DynamicComponent({
            loader: () => import('./Components/ProductImages'),
        });
        productImagesCarousel.forEach((element, index) => {
            const images = [...element.querySelectorAll('template')].map((img) => ({
                html: img.innerHTML,
                src: img.dataset.src,
                thumbnailSrcUrl: img.dataset.thumbnailSrc,
                extraDescription: img.dataset.extraDescription,
            }));
            if (images.length > 0) {
                renderReact(_jsx(Provider, { store: store, children: _jsx(ProductImages, { images: images }) }), element);
            }
        });
    }
    let productCarousels = document.querySelectorAll('.product-carousel__carousel');
    if (productCarousels.length) {
        const ProductCarousel = DynamicComponent({
            loader: () => import('./Components/ProductCarousel'),
        });
        productCarousels.forEach((element, index) => {
            const values = [...element.querySelectorAll('template')].map((block) => {
                return {
                    html: block.innerHTML,
                };
            });
            if (values.length > 0) {
                renderReact(_jsx(Provider, { store: store, children: _jsx(ProductCarousel, { values: values }) }), element);
            }
        });
    }
    let buyButtons = document.querySelectorAll('buy-button');
    if (buyButtons.length) {
        const BuyButton = DynamicComponent({
            loader: () => import('./Components/BuyButton'),
        });
        buyButtons.forEach((button) => {
            const { articleNumber, quantityFieldId, href, cssClass, label, } = button.dataset;
            renderReact(_jsx(Provider, { store: store, children: _jsx(BuyButton, { label,
                    articleNumber,
                    quantityFieldId,
                    href,
                    cssClass }) }), button);
        });
    }
    if (document.getElementById('orderHistoryPage')) {
        const OrderList = DynamicComponent({
            loader: () => import('./Components/OrderHistoryListContainer'),
        });
        renderReact(_jsx(Provider, { store: store, children: _jsx(OrderList, {}) }), document.getElementById('orderHistoryPage'));
    }
    if (document.getElementById('orderApproverPage')) {
        const OrderApproverList = DynamicComponent({
            loader: () => import('./Components/OrderApproverListContainer'),
        });
        renderReact(_jsx(Provider, { store: store, children: _jsx(OrderApproverList, {}) }), document.getElementById('orderApproverPage'));
    }
    let gridListSwitcherRoot = document.querySelector('grid-list-switcher');
    if (gridListSwitcherRoot) {
        const GridListSwitcher = DynamicComponent({
            loader: () => import('./Components/GridListSwitcher'),
        });
        let containerSelector = gridListSwitcherRoot.dataset.containerSelector;
        renderReact(_jsx(Provider, { store: store, children: _jsx(GridListSwitcher, { containerSelector }) }), gridListSwitcherRoot);
    }
    let overlay = document.getElementById('overlay');
    if (overlay) {
        const PageOverlay = DynamicComponent({
            loader: () => import('./Components/Overlay'),
        });
        renderReact(_jsx(Provider, { store: store, children: _jsx(PageOverlay, {}) }), overlay);
    }
    let filterTriggerButton = document.getElementById('filter-trigger-button');
    if (filterTriggerButton) {
        const FilterTriggerButton = DynamicComponent({
            loader: () => import('./Components/FilterTriggerButton'),
        });
        renderReact(_jsx(Provider, { store: store, children: _jsx(FilterTriggerButton, {}) }), filterTriggerButton);
    }
    let categoryTriggerButton = document.getElementById('category-trigger-button');
    if (categoryTriggerButton) {
        const CategoryTriggerButton = DynamicComponent({
            loader: () => import('./Components/CategoryTriggerButton'),
        });
        renderReact(_jsx(Provider, { store: store, children: _jsx(CategoryTriggerButton, {}) }), categoryTriggerButton);
    }
    let favoriteList = document.getElementById('favorite-list');
    if (favoriteList) {
        const FavoriteList = DynamicComponent({
            loader: () => import('./Components/Favorites/FavoritesList'),
        });
        renderReact(_jsx(Provider, { store: store, children: _jsx(FavoriteList, {}) }), favoriteList);
    }
    let retryTimeout = 0;
    let retryTimeoutDuration = 500;
    retryTimeout = setInterval(() => {
        let categoryFilterReact = document.getElementById('category-filter-react');
        if (categoryFilterReact) {
            let subNav = categoryFilterReact.querySelector('nav.subnav');
            if (subNav) {
                clearInterval(retryTimeout);
                const CategoryFilter = DynamicComponent({
                    loader: () => import('./Components/CategoryFilter'),
                });
                renderReact(_jsx(Provider, { store: store, children: _jsx(CategoryFilter, { filterElement: subNav.parentElement }) }), categoryFilterReact);
            }
        }
    }, retryTimeoutDuration);
    let jsFilterBrand = document.querySelectorAll('.js-filter-brands');
    if (jsFilterBrand.length > 0) {
        const brandItems = document.querySelectorAll('.brands-list > li');
        Array.from(jsFilterBrand).forEach((brandSelector) => {
            brandSelector.addEventListener('click', () => {
                brandItems.forEach((brand) => {
                    brand.classList.add('hidden');
                });
                document.querySelectorAll('.brands-list > li.js-lettergroup-' + brandSelector.dataset.letter + '').forEach((letterGroup) => {
                    letterGroup.classList.remove('hidden');
                });
            });
        });
    }
    let searchResultCategories = document.querySelector('#search-result-categories');
    if (searchResultCategories) {
        const SearchResultCategories = DynamicComponent({
            loader: () => import('./Components/SearchResultCategories'),
        });
        renderReact(_jsx(Provider, { store: store, children: _jsx(SearchResultCategories, { categoriesResult: window.__litium.categoriesResult }) }), searchResultCategories);
    }
    if (document.getElementById('organizationSearch')) {
        renderReact(_jsx(Provider, { store: store, children: _jsx(OrganizationSearch, {}) }), document.getElementById('organizationSearch'));
    }
};
bootstrapComponents();
